import { Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

export const LoggedOutLIWarning = (
	<Typography.Text type="danger">
		<WarningOutlined /> Reconnect your LinkedIn account
	</Typography.Text>
);
